import { format } from 'date-fns';

export const formatIsoDate = (isoDate: string) => {
    const date = new Date(isoDate);
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
};


export const getErrorCount = (errors: unknown): number => {
    if (!errors || typeof errors !== 'object') return 0;

    return Object.values(errors).reduce((count, value) => {
        if (typeof value === 'object' && value !== null) {
            return count + getErrorCount(value);
        }
        return count + 1;
    }, 0);

};

export const getNestedValue = (obj: any, path: string): any => {
    if (!obj || typeof path !== 'string') return undefined;

    const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');

    return keys.reduce((acc, key) => {
        if (acc === undefined || acc === null) return undefined;
        return acc[key];
    }, obj);
};
export const formatDate = (value: string | any) => {
    try {
        return format(new Date(value), 'yyyy-MM-dd');
    } catch {
        return value;
    }
}

export const formatDateTime = (value: string | any) => {
    try {
        const date = new Date(value);
        return format(date, 'yyyy-MM-dd') + ' ' + date.toLocaleTimeString();
    } catch {
        return value;
    }
}
